import styled from "styled-components";
import {motion} from "framer-motion";

export const Headline = styled(motion.div)`
    font-size: 4em;
    font-weight: 700;
    margin: 1.5rem;
    @media (max-width: 1050px) {
        font-size: 2.75em;
    }
    @media (max-width: 620px) {
        font-size: 2em;
    }
`;
export const Container = styled.div`
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
    text-align: center; 
    @media (max-width: 1050px) {
        width: 90%;
        padding-left: 1rem;
    }
`;
export const BrownRectangle = styled(motion.div)`
    width: 10rem;
    height: .5rem; 
    background-color: #B5734C; 
    margin-bottom: 2rem;
`;